<div class="page-breadcrumb">
  <div class="row d-flex justify-content-between">
    <div class="align-self-center ">
      <h3 class="page-title text-truncate text-dark font-weight-medium m-3 ml-4">Subject Management -
        {{ COutcomes[0]?.subject_code }} {{ COutcomes[0]?.subject_name }}
      </h3>
      <div class="d-flex align-items-center">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb m-0 p-0">
            <li class="breadcrumb-item"><a></a>
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="align-self-center">
      <a [routerLink]="['/routePath']" data-toggle="modal" data-target="#create-attainment-modal"
        class="ml-2 d-sm-inline btn btn-sm btn-primary shadow-sm"><i class="fa fa-plus fa-sm text-white-50"></i>
        Create Attainment </a>
      <a [routerLink]="['/routePath']" data-toggle="modal" data-target="#create-co-modal"
        class="ml-2 d-sm-inline btn btn-sm btn-primary shadow-sm"><i class="fa fa-plus fa-sm text-white-50"></i>
        Manage Course Outcomes </a>
      <a data-toggle="modal" data-target="#create-co-po-map-modal" [routerLink]="['/routePath']"
        class="ml-2 d-sm-inline btn btn-sm btn-primary shadow-sm"><i class="fa fa-plus fa-sm text-white-50"></i>
        CO - PO Table</a>
      <a [routerLink]="['/routePath']" class="ml-2 d-sm-inline btn btn-sm btn-primary shadow-sm"><i
          class="fa fa-plus fa-sm text-white-50"></i>
        Create Exam</a>
    </div>
  </div>
</div>
<hr>
<div class="page-breadcrumb pt-5">
  <div class="row d-flex justify-content-between">
    <div class="align-self-center ">
      <h3 class="page-title text-truncate text-dark font-weight-medium m-3 ml-4">List of Attainments
      </h3>
    </div>
    <div class="align-self-center">
      <a (click)=subject_detail_attainment() data-toggle="modal" data-target="#subject-co-modal"
        class="ml-2 float-right mx-5 text-white btn btn-sm btn-primary shadow-sm"><i
          class="fa fa-plus fa-sm text-white-50"></i>
        Generate Subject CO </a>
    </div>
  </div>
</div>
<div class="row attainments">
  <div *ngFor="let factor of Attainments" class="col-3">
    <div (click)="toAttDetail(factor)" class="card d-flex align-items-center">
      <p>{{factor.attainment_name}} : {{factor.attainment_value}}</p>
    </div>
  </div>
</div>

<hr>
<div class="page-breadcrumb pt-5">
  <div class="row d-flex justify-content-between">
    <div class="align-self-center ">
      <h3 class="page-title text-truncate text-dark font-weight-medium m-3 ml-4">List of Exams
      </h3>
    </div>
    <div class="align-self-center">
      <a (click)=subject_detail_attainment() data-toggle="modal" data-target="#subject-co-modal"
        class="ml-2 float-right mx-5 text-white btn btn-sm btn-primary shadow-sm"><i
          class="fa fa-plus fa-sm text-white-50"></i>
        Generate Subject CO </a>
    </div>
  </div>
</div>
<div class="row attainments">
  <div *ngFor="let factor of Exams" class="col-3">
    <div (click)="toExamDetail(factor)" class="card d-flex align-items-center">
      <p>{{factor.exam_name}}</p>
    </div>
  </div>
</div>


<!-- Coutcome Modal modal content -->
<div id="create-co-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <form #formValues4="ngForm" class="pl-3 pr-3">

          <!-- COutcomes name - machine_name - text - required -->
          <div class="form-group">
            <label>COutcomes name</label>
            <input class="form-control" [(ngModel)]="COutcomes.machine_name" name="machine_name" #machine_name="ngModel"
              type="text" placeholder="Enter COutcomes name" required>
            <div class="error" *ngIf="machine_name.touched && !machine_name.valid"> COutcomes name is
              required</div>
          </div>
          <!-- End of COutcomes name -->


          <div class="form-group text-center">
            <button class="btn btn-primary" type="submit">Add COutcomes</button>
          </div>


        </form>
        <mat-accordion>
          <mat-expansion-panel hideToggle *ngFor="let factor of COutcomes[0]['attainments']">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{factor.course_o_name}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-panel-description>
              {{factor.course_o_statement}}
            </mat-panel-description>
            <button class="btn btn-light">Delete Course Outcomes</button>
            <!-- <p>This is the primary content of the panel.</p> -->
          </mat-expansion-panel>
        </mat-accordion>

      </div>
    </div>
  </div>
</div>
<!-- End of Coutcome Modal -->

<!-- Coutcome PO Mapping Modal modal content -->
<div id="create-co-po-map-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-full-width">
    <div class="modal-content">
      <div class="modal-body">

        <div class="container">
          <div class="row">
            <table class="table table-hover table-striped">
              <thead>
                <tr>
                  <th>CO\PO - PSO</th>
                  <th>PO1</th>
                  <th>PO2</th>
                  <th>PO3</th>
                  <th>PO4</th>
                  <th>PO5</th>
                  <th>PO6</th>
                  <th>PO7</th>
                  <th>PO8</th>
                  <th>PO9</th>
                  <th>PO10</th>
                  <th>PO11</th>
                  <th>PO12</th>
                  <th>PSO1</th>
                  <th>PSO2</th>
                  <th>PSO3</th>
                </tr>
              </thead>
              <tbody>

                <tr class="form-group" *ngFor="let factor of COutcomes[0]['attainments']" contenteditable="true">
                  <th>{{factor.course_o_name}}</th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'po1')" [(ngModel)]=factor.po1></th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'po2')" [(ngModel)]=factor.po2></th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'po3')" [(ngModel)]=factor.po3></th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'po4')" [(ngModel)]=factor.po4></th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'po5')" [(ngModel)]=factor.po5></th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'po6')" [(ngModel)]=factor.po6></th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'po7')" [(ngModel)]=factor.po7></th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'po8')" [(ngModel)]=factor.po8></th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'po9')" [(ngModel)]=factor.po9></th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'po10')" [(ngModel)]=factor.po10>
                  </th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'po11')" [(ngModel)]=factor.po11>
                  </th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'po12')" [(ngModel)]=factor.po12>
                  </th>

                  <th><input class="form-control" (input)="update_po_map(factor, 'pso1')" [(ngModel)]=factor.pso1>
                  </th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'pso2')" [(ngModel)]=factor.pso2>
                  </th>
                  <th><input class="form-control" (input)="update_po_map(factor, 'pso3')" [(ngModel)]=factor.pso3>
                  </th>
                </tr>

                <tr class="form-group" contenteditable="true">
                  <th>PO Average</th>
                  <th>{{COutcomes[0].po1_average}}</th>
                  <th>{{COutcomes[0].po2_average}}</th>
                  <th>{{COutcomes[0].po3_average}}</th>
                  <th>{{COutcomes[0].po4_average}}</th>
                  <th>{{COutcomes[0].po5_average}}</th>
                  <th>{{COutcomes[0].po6_average}}</th>
                  <th>{{COutcomes[0].po7_average}}</th>
                  <th>{{COutcomes[0].po8_average}}</th>
                  <th>{{COutcomes[0].po9_average}}</th>
                  <th>{{COutcomes[0].po10_average}}</th>
                  <th>{{COutcomes[0].po11_average}}</th>
                  <th>{{COutcomes[0].po12_average}}</th>

                  <th>{{COutcomes[0].pso1_average}}</th>
                  <th>{{COutcomes[0].pso2_average}}</th>
                  <th>{{COutcomes[0].pso3_average}}</th>
                </tr>


                <tr class="form-group" contenteditable="true">
                  <th>PO Attainment</th>
                  <th>{{COutcomes[0].po1_attainment}}</th>
                  <th>{{COutcomes[0].po2_attainment}}</th>
                  <th>{{COutcomes[0].po3_attainment}}</th>
                  <th>{{COutcomes[0].po4_attainment}}</th>
                  <th>{{COutcomes[0].po5_attainment}}</th>
                  <th>{{COutcomes[0].po6_attainment}}</th>
                  <th>{{COutcomes[0].po7_attainment}}</th>
                  <th>{{COutcomes[0].po8_attainment}}</th>
                  <th>{{COutcomes[0].po9_attainment}}</th>
                  <th>{{COutcomes[0].po10_attainment}}</th>
                  <th>{{COutcomes[0].po11_attainment}}</th>
                  <th>{{COutcomes[0].po12_attainment}}</th>

                  <th>{{COutcomes[0].pso1_attainment}}</th>
                  <th>{{COutcomes[0].pso2_attainment}}</th>
                  <th>{{COutcomes[0].pso3_attainment}}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>
<!-- End of Coutcome PO Mapping Modal -->


<!-- Attainment Modal modal content -->
<div id="create-attainment-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <form #formValues4="ngForm" (ngSubmit)="create_factor(formValues4)" class="pl-3 pr-3">

          <!-- Attainment name - attainment_name - text - required -->
          <div class="form-group">
            <label>Attainment name</label>
            <input class="form-control" [(ngModel)]="Attainment.attainment_name" name="attainment_name"
              #attainment_name="ngModel" type="text" placeholder="Enter Attainment name" required>
            <div class="error" *ngIf="attainment_name.touched && !attainment_name.valid"> Attainment name is
              required</div>
          </div>
          <!-- End of Attainment name -->

          <!-- Attainment description - attainment_description - text - required -->
          <div class="form-group">
            <label>Attainment description</label>
            <input class="form-control" [(ngModel)]="Attainment.attainment_description" name="attainment_description"
              #attainment_description="ngModel" type="text" placeholder="Enter Attainment description" required>
            <div class="error" *ngIf="attainment_description.touched && !attainment_description   .valid"> Attainment
              name is
              required</div>
          </div>
          <!-- End of Attainment description -->

          <!-- Course Outcome - form - [ course_o_name - course_o_id ] - ng-select - selectedIndustry -->
          <div class="form-group">
            <label>Course Outcome</label>
            <ng-select [items]="COutcomes[0]['attainments']" bindLabel="course_o_name" autofocus bindValue="course_o_id"
              [(ngModel)]="Attainment.course_o" name="course_o" placeholder="Select Course Outcome">
            </ng-select>
          </div>
          <!-- End of Select Course Outcome -->

          <div class="form-group text-center">
            <button class="btn btn-primary" type="submit">Create Attainment</button>attainment_description
          </div>


        </form>
      </div>
    </div>
  </div>
</div>
<!-- End of Coutcome Modal -->



<!-- Coutcome PO Mapping Modal modal content -->
<div id="subject-co-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body">

        <div class="container">
          <div class="row">
            <table class="table">
              <thead>
                <tr>
                  <th>Particulars</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <th>Internal Attainment Average:</th>
                  <th>{{SubjectAttainment.internal_attainment}}</th>
                </tr>
                <tr>
                  <th>Internal Attainment Weightage:</th>
                  <th>
                    <input (input)="update_attainment()" [(ngModel)]=SubjectAttainment.internal_attainment_weightage>
                  </th>
                </tr>
                <tr>
                  <th>University Attainment Average:</th>
                  <th>{{SubjectAttainment.university_attainment}}</th>
                </tr>
                <tr>
                  <th>University Attainment Weightage:</th>
                  <th>
                    <input (input)="update_attainment()" [(ngModel)]=SubjectAttainment.university_attainment_weightage>
                  </th>
                </tr>
                <tr>
                  <th>Direct Attainment:</th>
                  <th>{{SubjectAttainment.direct_attainment}}</th>
                </tr>
                <tr>
                  <th>Direct Attainment Weightage:</th>
                  <th>
                    <input (input)="update_attainment()" [(ngModel)]=SubjectAttainment.direct_attainment_weightage>
                  </th>
                </tr>
                <tr>
                  <th>Indirect Attainment:</th>
                  <th>
                    <input (input)="update_attainment()" [(ngModel)]=SubjectAttainment.indirect_attainment></th>
                </tr>
                <tr>
                  <th>Indirect Attainment Weightage:</th>
                  <th>
                    <input (input)="update_attainment()" [(ngModel)]=SubjectAttainment.indirect_attainment_weightage>
                  </th>
                </tr>

                <tr>
                  <th>Final CO Attainment:</th>
                  <th>{{SubjectAttainment.subject_co_attainment}}</th>
                </tr>

              </tbody>
            </table>
            <!-- <a (click)=update_attainment()
                class="ml-2 float-right mx-5 text-white btn btn-sm btn-primary shadow-sm"><i
                  class="fa fa-plus fa-sm text-white-50"></i>
                Generate Subject CO </a> -->
          </div>
        </div>


      </div>
    </div>
  </div>
</div>
<!-- End of Coutcome PO Mapping Modal -->
